export default __webpack_public_path__ + "static/media/delete.e3bf1033.svg";